"use client";

import { c as _c } from "react-compiler-runtime";
import { createContext, type ReactNode, useContext } from "react";
import { useFaceLandmarker, type UseFaceLandmarkerOptions } from "./useFaceLandmarker";

// Share a single `useFaceLandmarker` across multiple stages so WASM + the
// face_landmarker.task model are fetched once per visit, and so the profile
// stage inherits an already-warmed, already-proven graph instead of rolling
// the native-node init dice a second time.
type FaceLandmarkerState = ReturnType<typeof useFaceLandmarker>;
const FaceLandmarkerContext = createContext<FaceLandmarkerState | null>(null);
type FaceLandmarkerProviderProps = {
  children: ReactNode;
} & UseFaceLandmarkerOptions;
export function FaceLandmarkerProvider(t0) {
  const $ = _c(6);
  const {
    children,
    tooCloseFaceSizeMax,
    enabled
  } = t0;
  let t1;
  if ($[0] !== enabled || $[1] !== tooCloseFaceSizeMax) {
    t1 = {
      tooCloseFaceSizeMax,
      enabled
    };
    $[0] = enabled;
    $[1] = tooCloseFaceSizeMax;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const landmarker = useFaceLandmarker(t1);
  let t2;
  if ($[3] !== children || $[4] !== landmarker) {
    t2 = <FaceLandmarkerContext.Provider value={landmarker}>{children}</FaceLandmarkerContext.Provider>;
    $[3] = children;
    $[4] = landmarker;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function useSharedFaceLandmarker() {
  const context = useContext(FaceLandmarkerContext);
  if (!context) {
    throw new Error("useSharedFaceLandmarker must be used within a <FaceLandmarkerProvider>. Wrap your capture flow in <FaceLandmarkerProvider> or call useFaceLandmarker directly if you intentionally want a standalone instance.");
  }
  return context;
}